"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePriceAfterDiscount = exports.getArrayFromRange = exports.toNearestCent = exports.formatMonetaryValue = exports.findLowestValue = exports.findHeighestValue = void 0;
const TDR_1 = __importDefault(require("../types/TDR"));
const findHeighestValue = (arr, property) => {
    if (!arr.length) {
        return null;
    }
    return arr.reduce((heighest, current) => {
        return typeof current === 'object'
            ? current[property] > heighest ? current[property] : heighest
            : current > heighest ? current : heighest;
    }, 0);
};
exports.findHeighestValue = findHeighestValue;
const findLowestValue = (arr, property) => {
    if (!arr.length) {
        return null;
    }
    return arr.reduce((lowest, current) => {
        return typeof current === 'object'
            ? current[property] < lowest ? current[property] : lowest
            : current < lowest ? current : lowest;
    }, Number.MAX_VALUE);
};
exports.findLowestValue = findLowestValue;
const formatMonetaryValue = (value, currency, noCents = false) => {
    const toFixed = (value !== null && value !== void 0 ? value : 0).toFixed(noCents ? 0 : 2);
    if (!currency) {
        return toFixed;
    }
    const currencyObj = TDR_1.default.CurrencyConfig[currency];
    return currencyObj.placement === TDR_1.default.CurrencyPlacement.BEFORE ? currencyObj.symbol + toFixed : toFixed + currencyObj.symbol;
};
exports.formatMonetaryValue = formatMonetaryValue;
const toNearestCent = (value) => {
    return Math.round(value * 100) / 100;
};
exports.toNearestCent = toNearestCent;
const getArrayFromRange = (startValue, endValue) => {
    const arr = [];
    for (let i = startValue; i <= endValue; i++) {
        arr.push(i);
    }
    return arr;
};
exports.getArrayFromRange = getArrayFromRange;
const calculatePriceAfterDiscount = (originalPrice, discountType, discountAmount) => {
    if (!discountType || !discountAmount) {
        return originalPrice;
    }
    let finalPrice = originalPrice; // if invalid discountType
    if (discountType === 'percent') {
        finalPrice = originalPrice * (100 - discountAmount) / 100;
    }
    else if (discountType === 'flat') {
        finalPrice = originalPrice - discountAmount;
    }
    else {
        throw new Error('discount type invalid');
    }
    return (0, exports.toNearestCent)(Math.max(finalPrice, 0));
};
exports.calculatePriceAfterDiscount = calculatePriceAfterDiscount;
//# sourceMappingURL=numerical.js.map